import React from 'react';
import get from 'src/utils/lodash-alternatives';
import {
  LaunchStrategiesContext,
  DEFAULT_GAME_STRATEGY,
} from './LaunchStrategiesProvider';
import {
  LaunchStrategyEnum,
  GameLaunchStrategies,
} from '../../types/gameTypes';
import { DeviceContext } from '../DeviceProvider/DeviceProvider';
import { isModalForMobileEnabled } from '../../logic/main/utils';
import { DeviceType } from '../../logic/main/types';
import { MOBILE_DEVICES } from '../../logic/main/constants';

export const getLaunchStrategyByParams = (
  integration: string,
  launchStrategies: GameLaunchStrategies | LaunchStrategyEnum[]
) => get(launchStrategies, integration, DEFAULT_GAME_STRATEGY);

export function GetGameLaunchStrategy(
  integration: string
): LaunchStrategyEnum | 'default' {
  const { launchStrategies } = React.useContext(LaunchStrategiesContext);
  return getLaunchStrategyByParams(integration, launchStrategies);
}

export function shouldUseModalForMobile(
  deviceType: DeviceType,
  launchStrategy: LaunchStrategyEnum
) {
  return (
    isModalForMobileEnabled &&
    MOBILE_DEVICES.includes(deviceType) &&
    launchStrategy === LaunchStrategyEnum.modalForMobile
  );
}

export function ShouldPreventDefaultForClick(integration?: string): boolean {
  const { launchStrategies, callbackMode } = React.useContext(
    LaunchStrategiesContext
  );
  const { deviceType, deviceNative: isNative } = React.useContext(
    DeviceContext
  );

  if (!integration) return callbackMode === 'event';

  const launchStrategy = getLaunchStrategyByParams(
    integration,
    launchStrategies
  );

  if (!isNative && launchStrategy === LaunchStrategyEnum.newWindow) return true;

  if (!isNative && shouldUseModalForMobile(deviceType, launchStrategy))
    return true;

  return callbackMode === 'event';
}
